export function formatJudgeName(raw: string): string {
  return raw
    .replace(/\bThe\s+Honourable\b/gi, '')
    .replace(/\bHonourable\b/gi, '')
    .replace(/\bThe\b/gi, '')
    .replace(/\bMr\.?Justice\b/gi, '')
    .replace(/\bMrs\.?Justice\b/gi, '')
    .replace(/\bMs\.?Justice\b/gi, '')
    .replace(/\bDr\.?Justice\b/gi, '')
    .replace(/\bMr\s+Justice\b/gi, '')
    .replace(/\bMrs\s+Justice\b/gi, '')
    .replace(/\bMs\s+Justice\b/gi, '')
    .replace(/\bDr\s+Justice\b/gi, '')
    .replace(/\bJustice\b/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
}
